// extracted by mini-css-extract-plugin
export default {"cards__list":"CardsContainer_cards__list__13R+1"};